import { createAsyncThunk } from "@reduxjs/toolkit";
import * as CampaignServiceApi from "apis/CampaignServiceApi";
import { setCampaignActivities } from "./campaignActivities.slice";

export const fetchCampaignActivities = createAsyncThunk(
  "campaigns/campaignActivities/fetchActivities",
  async (campaign_id: string, { dispatch, rejectWithValue }) => {
    try {
      const response = await CampaignServiceApi.getCampaignActivities({
        campaign_id,
      });

      if (Array.isArray(response)) {
        dispatch(setCampaignActivities(response));
      } else {
        rejectWithValue("Invalid activities response format");
      }
    } catch (error) {
      const err = error as { response?: { data?: { error?: string } } };
      rejectWithValue(
        err.response?.data?.error || "Failed to fetch campaign activities"
      );
    }
  }
);
